import { useState, useContext } from "react";
import './CartItem.css';
import { CiImageOn } from "react-icons/ci";
import { CartContext } from '../../context/CartContext';
import { useUser } from "../../context/UserProvider";
import { fetchAuthSession } from "aws-amplify/auth";
import axios from 'axios';
import { FaRegTrashCan } from "react-icons/fa6";


export default function CartItem(props) {
    const {
        index,
        image, 
        albumName, 
        productName, 
        albumId, 
        productId, 
        size, 
        price, 
        pages, 
        coverImage, 
        coverOptions,
        coverType, 
        coverName, 
        albumOptions, 
        productOptions,
        stripeProductId,
        stripePriceId,
        navbarImage,
        dupPriceId
    } = props;
    console.log("📦 CartItem Props:", props);
    console.log("🖼️ navbarImage in CartItem:", navbarImage);
    
    const [quantity, setQuantity] = useState(props.quantity || 1);
    const [imageError, setImageError] = useState(false);
    const { updateQuantity, removeFromCart, addToCart, setCartItems } = useContext(CartContext);
    const { cognitoUser, mongoUser } = useUser();
    const {duplicates, setDuplicates} = useState([])

    // ✅ Handle quantity change
    const handleQuantityChange = (e) => {
        const newQuantity = parseInt(e.target.value);
        setQuantity(newQuantity);
        updateQuantity(props.id, newQuantity); // Ensure ID is passed correctly
    };

    // ✅ Handle item removal with API call
    const handleRemoveItem = async () => {
        try {
            console.log("🔍 Checking index before removal:", index);
    
            // ✅ Ensure index is valid
            if (index === undefined || index < 0) {
                console.error("❌ Invalid index:", index);
                alert("Error: Unable to remove item. Invalid index.");
                return;
            }
    
            let idToken = null;
    
            // ✅ Only fetch session if user is logged in
            if (cognitoUser) {
                try {
                    const session = await fetchAuthSession();
                    idToken = session.tokens?.idToken?.toString();
                } catch (error) {
                    console.warn("⚠️ No authentication session found (guest user). Skipping API call.");
                }
            }
    
            if (cognitoUser && idToken) {
                // ✅ Authenticated user - call API to remove item
                const cognitoId = cognitoUser.userId
                await axios.delete(
                    `${import.meta.env.VITE_USERS_API}/user/${cognitoId}/cart`,
                    {
                        headers: {
                            'Authorization': `Bearer ${idToken}`,
                            'Content-Type': 'application/json'
                        },
                        data: { index },
                    }
                );
                console.log("✅ Item removed from cart in DB");
                setCartItems(prevCartItems => prevCartItems.filter((_, i) => i !== index));
            } else {
                // ✅ Guest user - remove from localStorage
                let guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
    
                if (index >= guestCart.length) {
                    console.error("❌ Index out of bounds:", index);
                    alert("Error: Unable to remove item.");
                    return;
                }
    
                guestCart.splice(index, 1); // ✅ Remove item by index
                localStorage.setItem("guestCart", JSON.stringify(guestCart));
                console.log("✅ Item removed from localStorage for guest user");
    
                // ✅ Update React state
                removeFromCart(index);
            }
    
        } catch (error) {
            console.error("❌ Error removing from cart:", error);
            alert("Failed to remove item from cart. Please try again.");
        }
    };
    
    
    

    // ✅ Handle adding duplicate item
    const handleAddDuplicate = () => {
        if (albumOptions?.dupPriceId) {
            const duplicateItem = {
                ...props,
                id: `${props.id}-duplicate`,
                isDuplicate: true,
                price: (price * 0.7).toFixed(2),
                albumOptions: { ...albumOptions },
                coverSelection: {
                    coverType,
                    coverName,
                    url: coverImage,
                },
            };
            addToCart(duplicateItem);
        }
    };

    return (
        <div className="cartItemContainer" value={index}>
            <div className="imageArea">
                {imageError ? (
                    <CiImageOn size={80} color="#ccc" />
                ) : (
                    <img
                        src={image}
                        alt="Product"
                        onError={() => setImageError(true)}
                    />
                )}
            </div>

            <div className="itemName">
                <h4>{albumName || 'Product Name'}</h4>
                <h6>Size: {size || 'N/A'}</h6>
                {albumName && <h6>Pages: {pages || 'N/A'}</h6>}
                <h6>Cover: {coverType || 'N/A'} - {coverName || 'N/A'}</h6>

                {coverImage ? (
                    <img 
                        src={coverImage}
                        alt="Cover Selection"
                        style={{ width: '50px', borderRadius: '15px' }} 
                    />
                ) : (
                    <CiImageOn size={80} color="#ccc" />
                )}
            </div>

            <div className="priceArea">
                <div className="quantPrice">
                    <input
                        type="number"
                        name="quantity"
                        min={1}
                        value={quantity}
                        onChange={handleQuantityChange}
                    />
                    <h5>${(price * quantity).toFixed(2)}</h5>
                </div>

                <div className="saveRemove">
                    <p 
                        onClick={handleRemoveItem} 
                        style={{ cursor: 'pointer', color: '#b99d8c' }}
                    >
                        Remove Item <FaRegTrashCan color="#b99d8c" width={20} height={20} />
                    </p>
                </div>

                {/* {albumOptions?.dupPriceId || productOptions?.dupPriceId && (
                    <div className="duplicateOption">
                        <button onClick={handleAddDuplicate} className="duplicateButton">
                            Add Duplicate
                        </button>
                        <span> 30% Off each duplicate item</span>
                    </div>
                )} */}
            </div>
             {/* Display duplicate items */}
             {/* {duplicates?.length > 0 && (
                <div className="duplicateItems">
                    {duplicates.map((dup, idx) => (
                        <div key={dup.id} className="duplicateItem">
                            <img src={dup.image} alt="Duplicate" style={{ width: '50px', borderRadius: '10px' }} />
                            <h6>Duplicate - ${dup.price}</h6>
                        </div>
                    ))}
                </div>
            )} */}
        </div>
    );
}
